import FillMethod from './FillMethod'
import { ecpmOrDefault, getTopUrl, loadScript, newContentFrame } from '../utils'
import Logger from '../Log'

const Log = Logger.for('AdPlusFillMethod')

export class AdPlusFillMethod extends FillMethod {
  constructor (bidder) {
    super('adplus', bidder, 'banner', ecpmOrDefault(bidder.params.ecpm, 0.2))
  }

  fill (adSlot, media) {
    return new Promise((resolve, reject) => {
      Log.debug('Running AdPlus fill method')
      const bidder = this._bidder

      newContentFrame(adSlot.node(), null, 1, 1).then(frame => {
        Log.debug('Loaded new frame for gpt')
        const div = frame.contentDocument.createElement('div')
        div.id = adSlot.nodeId() + '-gpt'
        frame.contentDocument.body.appendChild(div)

        loadScript('https://www.googletagservices.com/tag/js/gpt.js', frame.contentWindow).then(() => {
          const googletag = frame.contentWindow.googletag = frame.contentWindow.googletag || {}
          const cmd = googletag.cmd = googletag.cmd || []

          Log.debug('Loaded GPT script')
          cmd.push(() => {
            googletag.pubads().setTargeting('site', [bidder.params.site])
            googletag.pubads().set('page_url', getTopUrl())

            const ads = googletag.pubads()
            const slot = googletag.defineSlot(bidder.params.slotId, media.banner.sizes, div.id)
            slot.addService(ads)
            googletag.enableServices()

            let timeout = false
            let completed = false

            const to = setTimeout(() => {
              if (completed) return

              Log.info('GPT timeout fire, ready? ' + googletag.pubadsReady)
              timeout = true

              adSlot.node().removeChild(frame)

              resolve({ cpm: 0 })
            }, bidder.timeout || 2000)

            ads.addEventListener('slotRenderEnded', e => {
              if (e.slot === slot) {
                completed = true

                clearTimeout(to)

                if (e.isEmpty) {
                  Log.debug('Explicit no bid from GPT')
                  adSlot.node().removeChild(frame)
                  return resolve({ cpm: 0 })
                }

                if (timeout) {
                  // we have already resolved by now in timeout handler
                  return Log.info('GPT got response event but timed out!')
                }
              } else {
                return Log.debug('Ignoring gpt clear event for unknown slot ' + e.slot.getSlotElementId())
              }

              const cleared = e.isBackfill
              if (!cleared) {
                Log.debug('backFill false, did not fill')
                adSlot.node().removeChild(frame)
              } else {
                Log.debug('backFill true adplus filled')
              }

              frame.width = e.size[0]
              frame.height = e.size[1]

              resolve({
                cpm: cleared ? this.estValue() : 0,
                width: e.size[0],
                height: e.size[1]
              })
            })

            // This only requests the ad and writes it to div
            googletag.display(div)
            Log.debug('Requested AdPlus ad')
          })
        })
      })
    })
  }
}
